// extracted by mini-css-extract-plugin
export default {"termsOfServiceContainer":"TermsOfServiceContent_termsOfServiceContainer__jIVZa"};